<template>
  <div
    class="lg:text-4xl md:text-2xl text-xl text-center py-5 capitalize text-primary-gray-400 flex justify-center items-center p-2"
    :class="customClass"
  >
    <div
      class="rounded-lg w-fit p-1 borderborder-primary-gray-50"
      :class="isBlinking && 'shadow-purple-100 border-primary-purple-300'"
    >
      {{ $t(`attendanceTranslation.${text}`) }}
    </div>
  </div>
</template>

<script>
import { useBlinkField } from '@src/utils/layoutUtils.js'

export default {
  name: 'NoRecordFound',
  props: {
    text: {
      type: String,
      default: 'NO_RECORD_FOUND',
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      attendanceTranslation: 'attendanceTranslation',
    }
  },
  computed: {
    isBlinking() {
      return this.getBlinkField ? this.getBlinkField() : false
    },
  },
  watch: {
    blinkClassTrigger() {
      if (this.getBlinkField && !this.getBlinkField()) {
        this.startBlink()
      }
    },
  },
  created() {
    // Initialize generic blink field with key 'noRecordFound'
    const api = useBlinkField && useBlinkField('noRecordFound')
    if (api) {
      this.startBlink = api.startBlink
      this.stopBlinking = api.stopBlink
      this.getBlinkField = api.getBlink
    }
  },
}
</script>
